export const MAX_CHUNK_PARTS = 50;
